import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
        
    },
    getters:{
      
    },
    actions: {
        getVisits(obj, params) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits",
                    method: "GET",
                    params: params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        createVisit(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits",
                    data: obj,
                    method: "POST"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        deleteVisit(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + id,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        getVisit(obj, id) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + id,
                    method: 'GET'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        updateVisit(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id,
                    data: obj.data,
                    method: "PUT"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        notifyVisit(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + obj.id + '/notify',
                    method: 'PUT',
                    params: {
                        id_visit_person: obj.idVisitPerson,
                    },
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        getVisitsPeople(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id + "/people",
                    method: "GET",
                    params: obj.params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },

        getTagPreviewPeople(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id + "/people",
                    method: "GET",
                    params: obj.params
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        downoaldLabel(o, obj){
        

            // axios.defaults.headers.common['Content-Type'] = "application/octet-stream"
            // axios.defaults.headers.common['responseType'] = 'blob'
            
            axios.defaults.headers.common['accept'] = "application/octet-stream"
            axios.defaults.headers.common['responseType'] = 'blob'
            axios.defaults.headers.common['content-type'] = "application/octet-stream"
            const querystring = require('querystring')
            const queryparams = querystring.stringify(obj.params)
            return new Promise((resolve, reject) => {
             
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id + "/labels"+"?"+queryparams,
                    // method: 'GET',
                    // responseType: 'blob',
                    method: 'GET',
                    responseType: 'blob',
                    'content-type': 'application/octet-stream',
                    accept: "application/octet-stream",
                    'Access-Control-Allow-Origin': '*',
                    'userType': 'W',
                }).then(response => {
                    // delete axios.defaults.headers.common['blob']
                    // delete axios.defaults.headers.common['Content-Type']
                    // axios.defaults.headers.common['Accept'] = "application/octet-stream"

                    delete axios.defaults.headers.common['accept']
                    delete axios.defaults.headers.common['responseType']
                    delete axios.defaults.headers.common['content-type']
                    axios.defaults.headers.common['accept'] = "application/json"
                    if (response.data) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    // delete axios.defaults.headers.common['Content-Type']
                    // axios.defaults.headers.common['Accept'] = "application/octet-stream"
                    delete axios.defaults.headers.common['accept']
                    delete axios.defaults.headers.common['responseType']
                    delete axios.defaults.headers.common['content-type']
                    reject(error);
                });
            });
        },


        downloadPollResults(o, obj) {
            axios.defaults.headers.common['Accept'] = "application/octet-stream"
            axios.defaults.headers.common['Content-Type'] = "application/octet-stream"
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id + "/downloadPollResults",
                    method: 'GET',
                    params: obj.params,
                    responseType: 'blob',
                }).then(response => {
                    delete axios.defaults.headers.common['Accept']
                    delete axios.defaults.headers.common['Content-Type']
                    axios.defaults.headers.common['Accept'] = "application/json"
                    if (response.data) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    delete axios.defaults.headers.common['Accept']
                    delete axios.defaults.headers.common['Content-Type']
                    axios.defaults.headers.common['Accept'] = "application/json"
                    reject(error);
                });
            });
        },
        downloadPollResultsGeneral(o, obj) {
            axios.defaults.headers.common['Accept'] = "application/octet-stream"
            axios.defaults.headers.common['Content-Type'] = "application/octet-stream"
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/" + obj.id + "/downloadPollResults",
                    method: 'GET',
                    params: obj.params,
                    responseType: 'blob',
                }).then(response => {
                    delete axios.defaults.headers.common['Accept']
                    delete axios.defaults.headers.common['Content-Type']
                    axios.defaults.headers.common['Accept'] = "application/json"
                    if (response.data) {
                        resolve(response)
                    } else {
                        reject(response)
                    }
                }).catch(error => {
                    delete axios.defaults.headers.common['Accept']
                    delete axios.defaults.headers.common['Content-Type']
                    axios.defaults.headers.common['Accept'] = "application/json"
                    reject(error);
                });
            });
        },
        updateVisitPerson(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + obj.idVisit + '/people/' + obj.idVisitPerson,
                    data: obj.data,
                    method: "PUT"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        addVisitPerson(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + obj.idVisit + '/people',
                    data: obj.data,
                    method: "POST"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        addVisitParents(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + obj.idVisit + '/parents',
                    data: obj.data,
                    method: "POST"
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error)
                })
            });
        },
        deleteVisitPerson(o, obj) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + '/visits/' + obj.idVisit + '/people/' + obj.idVisitPerson,
                    method: 'DELETE'
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },
        getVisitPerson(o, code) {
            return new Promise((resolve, reject) => {
                axios({
                    url: process.env.VUE_APP_URL + "/visits/any/people/" + code,
                    method: "GET",
                }).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
      
    }
}